var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('logo'),_c('div',{staticClass:"account-container"},[_vm._t("default")],2),_vm._t("outside"),_c('footer',[_c('span',{staticClass:"copy-right"},[_vm._v(_vm._s(_vm.copyright))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }